import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-admin-admin-client-ap-configs',
  templateUrl: './admin-admin-client-ap-configs.component.html',
  styleUrl: './admin-admin-client-ap-configs.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AdminAdminClientApConfigsComponent {}
